import { PermissionModel } from '../../authorization/models';

export interface UpdateUserModel {
  partner_object_id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  language?: string;
  role?: string;
}
export interface AssignUserRoleModel {
  userObjectId: string;
  partnerObjectId: string;
  roleId: string;
}
export interface ResendInviteModel {
  user_oid: string;
}

export interface UserPasswordModel {
  oldPassword: string;
  newPassword: string;
}

export interface CreationUserPayloadModel {
  partner_object_id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  roles: string[];
}

export interface PartnerUsersResponseModel {
  numberOfItems: number;
  users: PartnerUserModel[];
}
export interface PartnerUserModel {
  objectId: string;
  fullName: string;
  email: string;
  status: string;
  avatar?: string;
  createdDate: string;
  roleId: number;
  roleName: string;
}
export interface UserProfile {
  object_id: string;
  fullName: string;
  email: string;
  firstName: string;
  lastName: string;
  street: string;
  postalCode: string;
  city: string;
  country: string;
  phone?: string;
  positionType: string;
  status: string;
  terms_of_service: '0' | '1';
  language: string;
  partners: Partner[];
}

export interface UserUpdateModel {
  object_id: string;
  fullName: string;
  email: string;
  firstName: string;
  lastName: string;
  street: string;
  postalCode: string;
  city: string;
  country: string;
  phone?: string;
  positionType: string;
  status: string;
  terms_of_service: '0' | '1';
  language: string;
  partners: Partner[];
}

export interface Partner {
  partnerOid: string;
  partnerName: string;
  roles: UserPartnerRoleModel[];
  is_active: boolean;
  is_initial_partner: boolean;
  partnerIds: string[];
}

export interface UserPartnerRoleModel {
  roleId: number;
  roleName: string;
}

export function getUserRole(user: UserProfile): UserPartnerRoleModel | undefined {
  const partner = user.partners.find(p => p.is_active);
  return partner?.roles[0];
}

export function getUserActivePartner(user?: UserProfile): Partner | undefined {
  return user?.partners.find(p => p.is_active);
}
export function getUserInitialPartner(user?: UserProfile): Partner | undefined {
  return user?.partners.find(p => p.is_initial_partner);
}

export function getUserFeaturePermissions(
  user: UserProfile | undefined,
  permissions: PermissionModel[] | undefined,
  xemexOid: string,
): string[] {
  const partnerOid = getUserActivePartner(user)?.partnerOid;
  return (
    permissions
      ?.filter(p => p.groupObjectId == partnerOid || p.groupObjectId == xemexOid)
      .flatMap(p => p.roles.flatMap(role => role.features.flatMap(f => f.features)))
      .filter(f => f.featureEnabled)
      .map(f => f.featureName) ?? []
  );
}
